// FETCH ALL PROPERTIES FROM YARN_INWARD DETAILS
export const FETCH_YARN_INWARD_DETAILS_REQUEST = 'FETCH_YARN_INWARD_DETAILS_REQUEST';
export const FETCH_YARN_INWARD_DETAILS_SUCCESS = 'FETCH_YARN_INWARD_DETAILS_SUCCESS';
export const FETCH_YARN_INWARD_DETAILS_FAILURE = 'FETCH_YARN_INWARD_DETAILS_FAILURE';

export const FETCH_YARN_INWARD_DETAILS_SO_AND_SN_REQUEST = 'FETCH_YARN_INWARD_DETAILS_SO_AND_SN_REQUEST';
export const FETCH_YARN_INWARD_DETAILS_SO_AND_SN_SUCCESS = 'FETCH_YARN_INWARD_DETAILS_SO_AND_SN_SUCCESS';
export const FETCH_YARN_INWARD_DETAILS_SO_AND_SN_FAILURE = 'FETCH_YARN_INWARD_DETAILS_SO_AND_SN_FAILURE';

// FETCH ALL PROPERTIES FROM YARN_INWARD DETAILS BY ID
export const FETCH_YARN_INWARD_DETAILS_BY_ID_REQUEST = 'FETCH_YARN_INWARD_DETAILS_BY_ID_REQUEST';
export const FETCH_YARN_INWARD_DETAILS_BY_ID_SUCCESS = 'FETCH_YARN_INWARD_DETAILS_BY_ID_SUCCESS';
export const FETCH_YARN_INWARD_DETAILS_BY_ID_FAILURE = 'FETCH_YARN_INWARD_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR YARN_INWARD DETAILS
export const CREATE_YARN_INWARD_DETAILS_REQUEST = 'CREATE_YARN_INWARD_DETAILS_REQUEST';
export const CREATE_YARN_INWARD_DETAILS_SUCCESS = 'CREATE_YARN_INWARD_DETAILS_SUCCESS';
export const CREATE_YARN_INWARD_DETAILS_FAILURE = 'CREATE_YARN_INWARD_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_INWARD_DETAILS = 'CREATE_USER_FORM_YARN_INWARD_DETAILS';

// UPDATE PROPERTIES FOR YARN_INWARD DETAILS
export const UPDATE_YARN_INWARD_DETAILS_REQUEST = 'UPDATE_YARN_INWARD_DETAILS_REQUEST';
export const UPDATE_YARN_INWARD_DETAILS_SUCCESS = 'UPDATE_YARN_INWARD_DETAILS_SUCCESS';
export const UPDATE_YARN_INWARD_DETAILS_FAILURE = 'UPDATE_YARN_INWARD_DETAILS_FAILURE';

// FETCH SINGLE YARN_INWARD_DETAILS
export const FETCH_SINGLE_YARN_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_YARN_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_YARN_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_YARN_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_YARN_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_YARN_INWARD_DETAILS_FAILURE';

// DELETE PROPERTIES FOR YARN_INWARD DETAILS
export const DELETE_YARN_INWARD_DETAILS_REQUEST = 'DELETE_YARN_INWARD_DETAILS_REQUEST';
export const DELETE_YARN_INWARD_DETAILS_SUCCESS = 'DELETE_YARN_INWARD_DETAILS_SUCCESS';
export const DELETE_YARN_INWARD_DETAILS_FAILURE = 'DELETE_YARN_INWARD_DETAILS_FAILURE';

// USERFORM RESET

export const YARN_INWARD_DETAILS_USERFORM_RESET = 'YARN_INWARD_DETAILS_USERFORM_RESET';

export const YARN_INWARD_DETAILS_PO_DETAILS_DISABLED = 'YARN_INWARD_DETAILS_PO_DETAILS_DISABLED';

// FETCH ALL PROPERTIES FROM YARN_INWARD DETAILS
export const FETCH_PREVIOUS_YARN_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_YARN_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_YARN_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_YARN_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_YARN_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_YARN_INWARD_DETAILS_FAILURE';
